var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.317969 7.82891L0.360156 7.87813L3.54766 11.5461C3.65547 11.6703 3.81719 11.7477 3.99766 11.7477C4.17812 11.7477 4.33984 11.668 4.44766 11.5461L7.63281 7.88516L7.68672 7.82422C7.72656 7.76562 7.75 7.69531 7.75 7.62031C7.75 7.41641 7.57656 7.25 7.36094 7.25H0.639062C0.423437 7.25 0.25 7.41641 0.25 7.62031C0.25 7.69766 0.275781 7.77031 0.317969 7.82891Z",
    fill: "#191919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68203 4.17109L7.63984 4.12187L4.45234 0.453907C4.34453 0.329688 4.18281 0.252344 4.00234 0.252344C3.82188 0.252344 3.66016 0.332031 3.55234 0.453907L0.367188 4.11484L0.313282 4.17578C0.273438 4.23437 0.25 4.30469 0.25 4.37969C0.25 4.58359 0.423438 4.75 0.639063 4.75L7.36094 4.75C7.57656 4.75 7.75 4.58359 7.75 4.37969C7.75 4.30234 7.72422 4.22969 7.68203 4.17109Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfold);
export default __webpack_public_path__ + "static/media/unfold.1247d918c3953de6364e879a5cd49b89.svg";
export { ForwardRef as ReactComponent };